export const GET_ALL_BOOKS = 'GET_ALL_BOOKS';
export const PUSH_BOOKS = 'PUSH_BOOKS';
export const PUSH_AUTHORS = 'PUSH_AUTHORS';

import firebase from 'firebase/app'
import 'firebase/firestore'

const state = {
    books: null,
    authors: null
};

const getters = {
    allBooks: state => state.books,
};

const actions = {
    [GET_ALL_BOOKS]: ({commit, dispatch}, page) => {
        return new Promise((resolve, reject) => {

        });
    },

    'GET_ID': ({commit, dispatch}) => {
        console.log('GET_ID')
        return new Promise(resolve => {
            let id = Date.now() + String(Math.random()).slice(-2)
            resolve(id)
        });
    },
};

const mutations = {
    [PUSH_BOOKS]: (state, books) => {
        state.books = books;
    },

    [PUSH_AUTHORS]: (state, authors) => {
        state.authors = authors;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}
